// extracted by mini-css-extract-plugin
export var errorsContainer = "_t4-1";
export var link = "_t4-0";